import { render } from "./callFollowUpListV2.vue?vue&type=template&id=62a22d58&scoped=true"
import script from "./callFollowUpListV2.vue?vue&type=script&lang=js"
export * from "./callFollowUpListV2.vue?vue&type=script&lang=js"

import "./callFollowUpListV2.vue?vue&type=style&index=0&id=62a22d58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a22d58"]])

export default __exports__